import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <div className="flex-1 flex items-center justify-center px-5 py-20 relative overflow-hidden">
        <div className="blob" style={{ width: 420, height: 420, background: "#15FF73", top: -100, left: "30%" }} />
        <div className="blob" style={{ width: 320, height: 320, background: "#FF1A8C", bottom: -80, right: -60, animationDelay: "-6s" }} />
        <div className="text-center relative">
          <div className="font-display text-[140px] sm:text-[220px] font-extrabold leading-none tracking-tight"><span className="text-rainbow">4</span><span className="text-[#0B0F0C]">0</span><span className="text-rainbow">4</span></div>
          <div className="text-2xl font-display font-extrabold mt-3">No gas down this road.</div>
          <p className="text-[#0B0F0C]/60 mt-2">The page rolled out before you got here.</p>
          <Link to="/" className="btn-x btn-primary mt-7">Back to the index →</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
